// angular
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';
import { AppService } from '../../../app.service';
import { MeDynamicReportService } from '../dynamic-report.service';

@Component({
    selector: 'me-dynamic-patient-onboarding',
    templateUrl: './onboarding.component.html',
    styleUrls: ['./onboarding.component.scss'],
    providers: [MeDynamicReportService]
})

export class MeDynamicOnboardingComponent implements OnInit {
    url = 'dynamic-report/onboarding';
    data = {};
    clusters = [];
    currentId = -1;
    activeCluster = null;
    percent = 0;
    color = '';
    showProgress = false;

    constructor(
        public translate: TranslateService,
        public appService: AppService,
        public router: Router,
        public route: ActivatedRoute,
        public coreService: CoreService,
        public meDynamicReportService: MeDynamicReportService
    ) {
       
    }

    ngOnInit() {
        this.getContent();
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content'] ?? [];
            this.data = contents;
            this.meDynamicReportService.getDynamicReport().subscribe(res => {
                this.clusters = res['clusters'];
                this.appService.isLoading = false;
            });       
        });
    }

    next() {
        this.currentId++;
        if (!this.clusters[this.currentId]) {
            this.router.navigate(['me/dashboard'],{
                queryParams: {
                    tab: 1
                }
            });
            return;
        }
        let uuid = this.clusters[this.currentId]['uuid'];
        this.appService.getStoryBlokSlugByUuid(uuid).subscribe(res => {
            this.activeCluster = res['story']['content'];
            this.percent = parseInt(this.activeCluster.prevalence);
            this.color = this.activeCluster.color.color;
        });
    }

    goBack() {
        this.router.navigate(['me/dashboard'], {
            queryParams: {
                tab: 1
            }
        });
    }
}
